import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = {
  class: "wTagContent"
};
const _hoisted_3 = {
  class: "wTagContent"
};
const _hoisted_4 = {
  key: 2
};
const _hoisted_5 = {
  class: "wTagContent"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_w_html_tool_tip = _resolveComponent("w-html-tool-tip");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  const _component_el_tag = _resolveComponent("el-tag");
  return _openBlock(), _createBlock(_component_el_tag, {
    "disable-transitions": true,
    class: _normalizeClass([{
      ellipsisClass: this.ellipsis
    }, "wTag"]),
    closable: _ctx.closable,
    size: _ctx.size,
    key: _ctx.textTag,
    round: _ctx.round,
    onClose: _cache[0] || (_cache[0] = $event => _ctx.removeTag($event))
  }, {
    default: _withCtx(() => [_ctx.hasHtmlTooltip ? (_openBlock(), _createBlock(_component_w_html_tool_tip, {
      key: 0,
      placement: _ctx.tooltipPlacement,
      disabled: _ctx.disabled
    }, {
      content: _withCtx(() => [_ctx.$slots.tooltip ? _renderSlot(_ctx.$slots, "tooltip", {
        key: 0
      }, undefined, true) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        innerHTML: _ctx.tooltipText
      }, null, 8, _hoisted_1))]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_ctx.icon ? (_openBlock(), _createBlock(_component_icon, {
        key: 0,
        icon: _ctx.icon,
        size: "small"
      }, null, 8, ["icon"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_ctx.textTag), 1)])]),
      _: 3
    }, 8, ["placement", "disabled"])) : _ctx.withToolTip ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 1,
      text: _ctx.textTag,
      placement: 'left'
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_ctx.icon ? (_openBlock(), _createBlock(_component_icon, {
        key: 0,
        icon: _ctx.icon,
        size: "small"
      }, null, 8, ["icon"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_ctx.textTag), 1)])]),
      _: 1
    }, 8, ["text"])) : (_openBlock(), _createElementBlock("span", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_ctx.icon ? (_openBlock(), _createBlock(_component_icon, {
      key: 0,
      icon: _ctx.icon,
      size: "small"
    }, null, 8, ["icon"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_ctx.textTag), 1)])]))]),
    _: 3
  }, 8, ["class", "closable", "size", "round"]);
}